import { ReactNode } from "react";

export function AppSection({ children }: {
  children: ReactNode;
})
{
  return (
<section>
  { children }
</section>
  )
}
